import VueRouter, { Route } from 'vue-router';
import { getItemFromSessionStorageAsBoolean } from './web-storage';
import { Link } from 'types/layout';
import { redirect } from './client';

export const handleRouting = async (link: Link, router: VueRouter): Promise<void> => {
	if (link.router) {
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		await router.push({ name: link.router, query: link.query, params: link.params }).catch(() => {});
	} else if (link.href) {
		redirect(link.href);
	} else {
		throw new Error('Routing error');
	}
};

export const stripRouteHash = (route: Route): string => {
	const fullPath = route.fullPath;
	const hashIndex = fullPath.indexOf('#');
	const queryIndex = fullPath.indexOf('?');
	if (hashIndex > -1) {
		if (queryIndex > hashIndex) {
			return fullPath.substring(0, hashIndex) + fullPath.substring(queryIndex, fullPath.length);
		}
		return fullPath.substring(0, hashIndex);
	}
	return fullPath;
};

export const checkChecklistRedirect = async (
	router: VueRouter,
	defaultRoute: string,
	routeParams?: Record<string, string>
): Promise<void> => {
	const isChecklistRedirect = getItemFromSessionStorageAsBoolean('redirect-to-checklist');
	if (isChecklistRedirect) {
		await router.push({ name: 'account-checklist' });
	} else {
		await router.push({ name: defaultRoute, params: routeParams });
	}
};
